<template>
  <div class="questionnaire-box" v-if="visible">
    <i class="el-icon-circle-close" @click.stop="visible = false"></i>
    <!-- <p>调查问卷入口</p> -->
    <div class="fake-btn" @click="$router.push('/questionnaire')"></div>
    <img :src="banner" alt="">
  </div>
</template>

<script>
import {ossPath} from "../../devParams"
export default {
  data() {
    return {
      banner: ossPath + "/pages/home/questionnaire-entry.png",
      visible: true
    }
  }
}
</script>

<style lang="scss" scoped>
.questionnaire-box {
  position: fixed;
  bottom: 0;
  width: 100%;
  // height: 100px;
  background: #fff;
  border-top: 1px solid #efefef;
  text-align: center;
  font-size: 0;
  z-index: 9;
  img {
    width: 100%;
    // height: 100px;
  }
}
.el-icon-circle-close {
  position: absolute;
  top: 50%;
  right: 20px;
  margin-top: -8px;
  font-size: 16px;
  cursor: pointer;
}
.fake-btn {
  position: absolute;
  bottom: 50%;
  right: 42%;
  width: 120px;
  height: 30px;
  margin-right: -60px;
  margin-bottom: -14px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// common/questionnaireBar/index.vue